import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {getSysLogs} from "apollo/queries/getSysLogs";
import {fetchError} from "../actions/Common";
import {fetchSysLogsSuccess} from "../actions/Logs";
import {client} from "apollo/client";

import {
  FETCHSYSLOGS
} from "constants/ActionTypes";

const getSysLogsRequest = async (start, end) => {
  try {
    let { data, error } = await client.query({
      query: getSysLogs,
      variables: {
        start: start,
        end: end
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('error', e);
    return Promise.reject(e);
  }
}

function* getSysLogsCall({payload}) {
  const {start, end} = payload;

  try {
    const fetchedSysLogs = yield call(getSysLogsRequest, start, end);
    yield put(fetchSysLogsSuccess(fetchedSysLogs));
  } catch (error) {
    yield put(fetchError(error));
  }
}

export function* fetchSysLogs() {
  yield takeEvery(FETCHSYSLOGS, getSysLogsCall);
}

export default function* rootSaga() {
  yield all([fork(fetchSysLogs)]);
}
